import { fetchQuery } from "relay-runtime";
import environment from "environments/environment";
import getAssetCategoryIdQuery from "./queries/getAssetCategoryId";
import getPropertiesQuery from "./queries/getProperties";
import getOrgQuery from "./queries/getOrg";
import getSuborgDetailsQuery from "./queries/getSuborgDetails";

const getDefaultOrg = (appName) => {
  let variables = { appName, first: 1 };
  return fetchQuery(environment, getOrgQuery, variables)
}

const getAssetCategoryId = (propertyId, type) => {
  let variables = { propertyId, type };
  return fetchQuery(environment, getAssetCategoryIdQuery, variables).then(res => {
    if (res.categories) return res.categories[0].id;
    return ""
  })
    .catch(err => {
      return { errors: [{ message: err.toString() }] };
    });
}

const loadProperties = (orgId) => {
  let variables = { orgId };
  return fetchQuery(environment, getPropertiesQuery, variables).then(res => {
    if (res.authorizedSuborgs) return res.authorizedSuborgs;
    return []
  })
    .catch(err => {
      return { errors: [{ message: err.toString() }] };
    });
}

const getSuborgDetails = (id) => {
  let variables = { id };
  return fetchQuery(environment, getSuborgDetailsQuery, variables)
}


export {
  getAssetCategoryId,
  loadProperties,
  getDefaultOrg,
  getSuborgDetails
};